"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _SortDown = _interopRequireDefault(require("@rsuite/icon-font/lib/direction/SortDown"));

// Generated by script, don't edit it please.
var SortDown = (0, _createSvgIcon["default"])({
  as: _SortDown["default"],
  ariaLabel: 'sort down',
  category: 'direction',
  displayName: 'SortDown'
});
var _default = SortDown;
exports["default"] = _default;
module.exports = exports.default;